$(document).ready(function(){
  $(document).on("click",".announcement_text-close",function(){
     $('.section-id-announcement-bar').hide();
     $('.Product_nameUnique').html("");
  })

  // Add To Cart Product Js Line 
  
  $(document).on("click",".Product-addToCart-btn",function(){
  var vrt_id = $(this).data('product_variant_id');
  var vrt_title = $(this).data('product_title');
  productAddToCart(vrt_id, 1, vrt_title);
})

 $(document).on('click',".ProductPage_AddToCart",function(){
    var title = $(this).data("product_title");
    $('.Product_nameUnique').html(title);
     setTimeout(function(){
    $('.section-id-announcement-bar').show();
     },1000);
    setTimeout(function(){
        $('.section-id-announcement-bar').hide();
        $('.Product_nameUnique').html("");
    },5000);
  })
  
function productAddToCart(id, qty, title){
    var data = {
        id: id,
        quantity: qty
    }
    $.ajax({
        url: '/cart/add.js',
        type: "POST",
        data: data,
        dataType: "JSON",
        success: function(){
          $.getJSON('/cart',function(cart){
            var countItem = cart.item_count;
            if(countItem < 2){
              console.log("yes less then 2");
              $('.cart-link__icon').append("<span class='cart-link__count'>"+countItem+"</span>");
            }else{
              console.log("no more then 2");
            $('.cart-link__count').html(countItem);
            }
          })
            $('.Product_nameUnique').html(title);
            $('.section-id-announcement-bar').show();
            setTimeout(function(){
                $('.section-id-announcement-bar').hide();
                $('.Product_nameUnique').html("");
            },3000);
        }
    })
}
});
